import {
  DisableIntegrationRequestPathParamType,
  DisableIntegrationResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { integrationKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const disableIntegration = async (
  payload: ApiRequest<any, DisableIntegrationRequestPathParamType>
) => {
  const resp = await api.delete<DisableIntegrationResponseBodyType>(
    `/v2/integrations/${payload.pathParams.id}`
  );
  return resp.data;
};
export const useDisableIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation<
    DisableIntegrationResponseBodyType,
    Error,
    ApiRequest<any, DisableIntegrationRequestPathParamType>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<any, DisableIntegrationRequestPathParamType>
    ) => disableIntegration(data),
    onSuccess: async () => {
      void queryClient.invalidateQueries({ queryKey: integrationKeys.all });
    },
  });
};
